import customfn from "@/_functions.js";

$(function () {

    $(document).on('click', '#edit-inventory-groups', function (ev) {
        ev.preventDefault();
        customfn.getModal($(this).attr('href'));
    })


    // Save the groups
    // If the next button is clicked, get the form fields and post ti.
    $(document).on('click', '.select-inventory-groups button.save-inventory-groups', function(ev){
        ev.preventDefault();
        var form = $(this).closest('.modal').find('form.save-inventory-groups'),
            formFields = form.serialize(),
            url = form.attr('action'),
            button = $(this);

        customfn.setButtonLoadingStateForSelector('#modal-wrapper .modal button[data-loading-text]');
        $.ajax(url, {
            method: "POST",
            data: formFields,
            success: function (data) {
                customfn.hideModals();
                if(data.html) {
                    $('.sub-inventory-groups > div:first').html(data.html);

                    // Reset typeahead
                    if($('input.typeahead').length > 0){
                        $('input.typeahead').each(function(){
                            customfn.typeAhead($(this))
                        });
                    }

                    // Reset chosen
                    $("select.chosen-select").chosen({no_results_text: "Oops, nothing found!", width: '100%'}).addClass("replaced");;

                }

                // Refresh the access overview
                var $accessOverview = $(document).find('.access_rci');
                var url = $accessOverview.data('refresh-url');
                if (typeof url != 'undefined') {
                    $.get(url, function (data) {
                        if (data.html) {
                            $accessOverview.html(data.html);
                        }
                    })
                }
            },
            error: function (jqXHR) {
                if(jqXHR.responseJSON) {
                    var data = jqXHR.responseJSON;
                    customfn.showModal(data);
                }
                customfn.resetButtonLoadingState(button);
            }
        });

    });


});
